
import XButton from 'vux/src/components/x-button/index.vue'

import {CellRow} from '@/components';
import utils from '@/utils/utils';
import AllinpayRequirement from './AllinpayRequirement';
import {OrderProxy} from '@/http/RequestProxy.class.js';

export default {
name: 'payment-instance',
components: {
CellRow,
XButton,
AllinpayRequirement,
},
props: {
currency: {
type: String,
default: window.localStorage.getItem('currency_code') || 'CNY'
},
totalAmount: {
type: Number | String,
default: 0,
},

dueAmount: Number | String,

creditCarData: Object,  // 中行外卡和通联支付相关数据
},
data(){
return {
isWechat: true,
total: this.totalAmount,  // 支付总金额
thirdPayment: 'wechat_pay',
paymentId: 1,

isSelectBalance: false,   // 选择余额支付
isShowSurplus: false,     // 显示余额结余
isSelectBcc: false,       // 选择bcc支付
isShowBccSurplus: false,  // 显示bcc结余

foreignRate: 0,       // 中行外卡手续费率
foreignCardFee: 0,    // 中行外卡手续费
allinPayRate: 0,      // 通联支付手续费率
allinPayFee: 0,       // 通联支付手续费
feeStr: '',           // 手续费提示多语言内容

userWallet: {         // 用户钱包相关信息
bcc: {}
},
bccAccountSurplus: 0, // bcc账户余额

balance: 0,           // 账户余额
accountSurplus: 0,    // 账户余额结余
};
},
watch: {
totalAmount(cur){
this.total = cur;
},

dueAmount(cur){
setTimeout(() => {
this.foreignCardFee = Math.ceil(Number(cur) * (Number(this.foreignRate) / 100));
this.allinPayFee = Math.ceil(Number(cur) * (Number(this.allinPayRate) / 100));
}, 100);
},

creditCarData(newData){
this.foreignRate = newData.visa;         
this.allinPayRate = newData.allinpay;    
this.feeStr = newData.str_addition_fee;  
},
},
mounted(){
const isWx = utils.isWechatBrowser();

this.isWechat = isWx;
if(!isWx){
this.thirdPayment = 'alipay';
this.paymentId = 2;
}

this.getUserWallet();
},
methods: {
/** 获取用户的钱包信息 */
getUserWallet(){
new OrderProxy().getUserWallet()
.then(resp => {
if(resp){
this.userWallet = resp.data;
this.balance = resp.data.balance;
this.$emit('on-get-bcc-data', resp.data.bcc);
}
});
},

/** 选择账户余额 */
onSelectBalance(){
this.isSelectBalance = !this.isSelectBalance;
this.isShowSurplus = !this.isShowSurplus;

this.$emit('on-use-account', this.calcBalance());
},

/** 选择bcc支付 */
onSelectBcc(){
this.isSelectBcc = !this.isSelectBcc;
this.isShowBccSurplus = !this.isShowBccSurplus;
this.$emit('on-use-account', this.calcBalance());
},

/** 选择第三方支付方式 */
onSelectThirdPayment(payType, typeId){
this.thirdPayment = payType;
this.paymentId = typeId;
this.$emit('on-payment', typeId);
},

/** 账户余额和bcc结余计算 */
calcBalance(){
const balanceBool = this.isSelectBalance,
bccBool = this.isSelectBcc;

let useBalance = 0, // 使用的账户金额
useBcc = 0;     

if(balanceBool && !bccBool){
if(+this.balance >= +this.total){
this.accountSurplus = (Number(this.balance) - Number(this.total)).toFixed(2);
useBalance = this.total;
}else{
this.accountSurplus = 0;
useBalance = this.balance;
}

useBcc = 0;
this.bccAccountSurplus = 0;
}else if(!balanceBool && bccBool){
if(+this.userWallet.bcc.balance >= +this.total){
this.bccAccountSurplus = (this.userWallet.bcc.balance - this.total).toFixed(2);
useBcc = this.total;
}else{
this.bccAccountSurplus = 0;
useBcc = this.userWallet.bcc.balance;
}

useBalance = 0;
this.accountSurplus = 0;
}else if(balanceBool && bccBool){
let subAmount = 0;  

if(+this.balance >= +this.total){
this.accountSurplus = (this.balance - this.total).toFixed(2);
useBalance = this.total;

this.bccAccountSurplus = this.userWallet.bcc.balance;
useBcc = 0;
}else{
subAmount = this.total - this.balance;
useBalance = this.balance;
this.accountSurplus = 0;

if(+this.userWallet.bcc.balance >= subAmount){
this.bccAccountSurplus = (this.userWallet.bcc.balance - subAmount).toFixed(2);
useBcc = subAmount;
}else{
this.bccAccountSurplus = 0;
useBcc = this.userWallet.bcc.balance;
}
}
}else{
this.accountSurplus = 0;
this.bccAccountSurplus = 0;
useBalance = 0;
useBcc = 0;
}

return {useBalance: useBalance, useBcc: useBcc};
},

/** 获取输入的卡号信息 */
getCard(cardOptions){
this.$emit('on-get-allin-card', cardOptions);
},

/** 发起支付 */
onGotoPay(){
this.$emit('on-submit');
},
},
}



// WEBPACK FOOTER //
// ./src/views/payment/components/PaymentInstance.vue